var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 16L14 18.6667L14 13.3333L18.6667 16Z",
    fill: "#BED6EF",
    stroke: "#BED6EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66662 16.9427L2.66662 15.056C2.66663 11.196 2.66663 9.26536 3.87329 8.02402C5.08129 6.78136 6.98263 6.72802 10.784 6.62002C12.584 6.56936 14.424 6.53336 16 6.53336C17.5746 6.53336 19.4146 6.56936 21.216 6.62003C25.0173 6.72803 26.9186 6.78136 28.1253 8.02403C29.3333 9.26536 29.3333 11.1974 29.3333 15.056L29.3333 16.9427C29.3333 20.804 29.3333 22.7334 28.1266 23.976C26.9186 25.2174 25.0186 25.272 21.216 25.3787C19.416 25.4307 17.576 25.4667 16 25.4667C14.261 25.4615 12.5221 25.4321 10.784 25.3787C6.98262 25.272 5.08129 25.2187 3.87329 23.976C2.66662 22.7334 2.66662 20.8027 2.66662 16.944L2.66662 16.9427Z",
    stroke: "#BED6EF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.775470cfdeee613cddcdf52519e2c50d.svg";
export { ForwardRef as ReactComponent };